import { NbJSThemeOptions, DARK_THEME as baseTheme } from '@nebular/theme';

export const CORPORATE_BLUE_DARK_THEME = {
  name: 'corporate-blue-dark',
  base: 'dark',
  variables: {
    // Solo cambiar los colores principales
    primary: '#2196f3',
    success: '#4caf50',
    warning: '#ff9800',
    danger: '#f44336',
    info: '#03a9f4',
  },
}; 